import CheckboxField from './checkbox-field/checkbox-field';
import CheckboxlistField from './checkbox-list-field/checkbox-list-field';
import DisplayOnlyField from './display-only-field/display-only-field';
import LookupField from './lookup-field/lookup-field';
import RadioField from './radio-field/radio-field';
import RelatedListField from './related-list-field/related-list-field';
import SelectField from './select-field/select-field';
import TextField from './text-field/text-field';
import ToggleSelectField from './toggle-select-field/toggle-select-field';
import TypeaheadField from './typeahead-field/typeahead-field';

const formFields = angular
    .module('FacilityData.EnterData.FormFields', [
        CheckboxField,
        CheckboxlistField,
        DisplayOnlyField,
        LookupField,
        RadioField,
        RelatedListField,
        SelectField,
        TextField,
        ToggleSelectField,
        TypeaheadField
    ])
    .name;

export default formFields;



// WEBPACK FOOTER //
// ./app/common/form-fields/form-fields.js